module.exports = __webpack_public_path__ + "img/2020-2-1_25c0f3bdf.png";